/**
 * @file The example list insight component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InsightListComponent } from '../insight-list/insight-list.component';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../../insights/insight.service';
import { LocalisationService } from '../../core/localisation.service';
import { ComponentRegistry } from '../../core/component-registry';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Insight component that shows a List (with a flag).
 */
var InsightExampleListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightExampleListComponent, _super);
    /**
     * Constructs an InsightExampleListComponent
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightExampleListComponent(resourceService, provider, insightService, localisationService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.alertsService = alertsService;
        _this.setData([
            { name: 'Vestibulum ante ipsum primis in faucibus orci luctus', value: '220 hr', percentage: 20 },
            { name: 'Donec et', value: '165 hr', percentage: 15 },
            { name: 'Donec et', value: '440 hr', percentage: 40 },
            { name: 'Proin iaculis', value: '660 hr', percentage: 60 },
            { name: 'Proin iaculis', value: '880 hr', percentage: 80 }
        ]);
        return _this;
    }
    /**
     * Register component by the insight provider
     */
    InsightExampleListComponent.register = function () {
        ComponentRegistry.register('insight', 'InsightExampleListComponent', InsightExampleListComponent);
    };
    return InsightExampleListComponent;
}(InsightListComponent));
export { InsightExampleListComponent };
